import React, { useState } from 'react'

import { cloneDeep } from 'lodash/lang'

const withState = WrappedComponent => {
  return props => {
    const {
      parent, // via withQuery
      queryLoading, // via withQuery
      setParentFormField, // via redux actions
      setParentForm // via redux actions
    } = props

    const [formLoading, setFormLoading] = useState(true)
    const [token, setToken] = useState()

    const initialFormValues = {
      firstName: '',
      lastName: '',
      relationshipToCampers: '',
      legalGuardian: '',
      primaryPhone: '',
      alternatePhone: '',
      streetAddress: '',
      city: '',
      region: '',
      country: 'US',
      postalCode: '',
      email: '',
      accountAccess: '',
      pickup: ''
    }

    if (formLoading && !queryLoading) {
      setParentForm(cloneDeep(initialFormValues))
      if (parent) {
        setParentFormField('streetAddress', parent.streetAddress)
        setParentFormField('city', parent.city)
        setParentFormField('region', parent.region)
        setParentFormField('country', parent.country)
        setParentFormField('postalCode', parent.postalCode)
      }
      setFormLoading(false)
    }

    return <WrappedComponent formLoading={formLoading} token={token} setToken={setToken} {...props} />
  }
}

export default withState
